<template>
  <div
    class="app-checkbox"
    @click="toggle"
    :class="{
      checked: modelValue === true,
      indeterminate: modelValue === 'indeterminate',
    }"
  >
    <span class="checkmark"></span>
  </div>
</template>

<script>
export default {
  name: "AppCheckbox",

  props: {
    modelValue: {
      type: [Boolean, String],
      default: false,
    },
  },

  emits: ["update:modelValue"],

  methods: {
    toggle() {
      let next;

      if (this.modelValue === true) {
        next = false;
      } else {
        next = true;
      }

      this.$emit("update:modelValue", next);
    },
  },
};
</script>

<style scoped lang="less">
.app-checkbox {
  width: 17px;
  height: 17px;
  min-height: 17px;
  min-width: 17px;
  border-radius: 2px;
  border: 2px solid #cfd8dd;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;

  .checkmark {
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  &.checked {
    background: #7d919b;
    border-color: #7d919b;
    .checkmark {
      position: absolute;
      width: 12px;
      height: 7px;
      border-left: 2px solid white;
      border-bottom: 2px solid white;
      transform: rotate(-45deg);
      bottom: 5px;
      opacity: 1;
    }
  }

  &.indeterminate {
    background: #7d919b;
    border-color: #7d919b;
    .checkmark {
      position: absolute;
      width: 10px;
      bottom: 5.5px;
      border-bottom: 2px solid white;
      opacity: 1;
    }
  }
}
</style>
